/* eslint-disable camelcase */
import Store from 'src/store';
import registerVuexModuleIfNotExists from 'src/utils/registerVuexModuleIfNotExists';
import { actingUserHasControlledAction } from 'src/utils/actingUser';
import fetchRecords from 'src/utils/entityOperations/fetchRecords';
import setCurrentMode from 'src/utils/currentMode/setCurrentMode';
import Account from 'src/platform/pages/Account.vue';
import getSessionContext from 'src/utils/context/getSessionContext';
import registerVuexModule_overrideExisting from 'src/utils/registerVuexModule_overrideExisting';
import meta__table_views from 'src/store/meta/table_views/table_views';
import arrayHasMembers from 'src/utils/arrayOperations/arrayHasMembers';
import { setCurrentApplicationEntityModel } from 'src/types/applicationEntityModel/applicationEntityModel';
const fetchIsAllowed = (entity) => {
    let controlledActions;
    try {
        controlledActions = Store.getters[entity + '/controlledActions'];
    }
    catch (e) {
        console.warn(`controlledActions not found for ${entity} at this time.  Will try again later.`);
    }
    const fetchCA = controlledActions === null || controlledActions === void 0 ? void 0 : controlledActions.fetch;
    if (fetchCA === 0 /* anyone can */) {
        return true;
    }
    else if (!fetchCA) {
        console.warn(`controlledActions.fetch not found for ${entity}`);
        return false;
    }
    else {
        return actingUserHasControlledAction(fetchCA);
    }
};
export function fetchMaster(entity) { fetchRecords(entity, { saveAlsoAsFullTable: true, payload: { pagination: { page_size: 9999999 } } }); }
export function fetchMasters(mastersToFetch, backoffSec = 1) {
    const allowed = mastersToFetch.filter(fetchIsAllowed);
    const notAllowed = mastersToFetch.filter(entity => !allowed.includes(entity));
    allowed.forEach(fetchMaster);
    if (arrayHasMembers(notAllowed)) {
        if (backoffSec > 128 /* 2 minutes */) {
            console.warn(`fetchMasters: not allowed to fetch ${notAllowed.join(', ')}.  Giving up.`);
        }
        else {
            console.warn(`fetchMasters: not allowed to fetch ${notAllowed.join(', ')}.  Will try again in ${backoffSec} seconds.`);
            setTimeout(() => fetchMasters(notAllowed, backoffSec * 2), backoffSec * 1000);
        }
    }
}
export default function initializeApp(params) {
    const { vuexModulesToRegister, mastersToFetch, documentTitle, currentModeParams, applicationEntityModel } = params;
    const vuexModulesToRegister_ = Object.assign(Object.assign({}, vuexModulesToRegister), { 'meta.table_views': meta__table_views });
    document.title = documentTitle || 'Sonar';
    const appId = getSessionContext().app_id;
    const defaultMasters = [
        'orgs.orgs',
        'apps.apps',
        'preferences.user_preferences',
        'preferences.option_user_values',
        'preferences.option_groups',
        'meta.table_views',
    ];
    // register app-specific vuex modules
    // starting app 24PlatformAdmin, behavior of registerVuexModuleIfNotExists is changed to override existing module.  Overriding works only for dynamically registered vuex modules
    if (typeof appId === 'number' && appId >= 24) {
        for (const name in vuexModulesToRegister_) {
            registerVuexModule_overrideExisting(name, vuexModulesToRegister_[name]);
        }
    }
    else {
        for (const name in vuexModulesToRegister_) {
            registerVuexModuleIfNotExists(name, vuexModulesToRegister_[name]);
        }
    }
    const mastersToFetch_ = [...defaultMasters, ...(mastersToFetch || [])];
    fetchMasters(mastersToFetch_);
    if (applicationEntityModel) {
        setCurrentApplicationEntityModel(applicationEntityModel);
    }
    setCurrentMode(currentModeParams || { component: Account });
}
